import angular from 'angular';

export default angular.module('cms.pagination-controls', [])
    .component('paginationControls', {
        template: require('./pagination-controls.html'),
        bindings: {
            pages: '<',
            currentPage: '<',
            onPageChange: '&'
        },
        controller: function () {
            this.aroundEdges = 2;
            this.aroundCurrent = 1;
            this.pageControls = [];

            this.generatePages = () => {
                this.pageControls.length = 0;
                let pageControls = this.pageControls;

                if (this.currentPage > this.aroundEdges + this.aroundCurrent) {
                    for (let i = 1; i <= this.aroundEdges; i++) {
                        pageControls.push({
                            label: i,
                            page: i
                        })
                    }

                    pageControls.push({
                        label: '...',
                        disabled: true,
                        page: '-1'
                    });

                    for (let i = this.currentPage - this.aroundCurrent; i < this.currentPage; i++) {
                        pageControls.push({
                            label: i,
                            page: i
                        })
                    }
                } else {
                    for (let i = 1; i < this.currentPage; i++) {
                        pageControls.push({
                            label: i,
                            page: i
                        })
                    }
                }

                pageControls.push({
                    label: this.currentPage || '...',
                    page: this.currentPage
                });

                if (this.currentPage < this.pages - this.aroundEdges - this.aroundCurrent) {
                    for (let i = this.currentPage + 1; i <= this.currentPage + this.aroundCurrent; i++) {
                        pageControls.push({
                            label: i,
                            page: i
                        })
                    }
                    pageControls.push({
                        label: '...',
                        disabled: true,
                        page: '-2'
                    });

                    for (let i = this.pages - this.aroundEdges + 1 ; i <= this.pages; i++) {
                        pageControls.push({
                            label: i,
                            page: i
                        })
                    }

                } else {
                    for (let i = this.currentPage + 1; i <= this.pages; i++) {
                        pageControls.push({
                            label: i,
                            page: i
                        })
                    }
                }
            };

            this.$onInit = () => {
                this.generatePages();
            };

            this.$onChanges = ({pages: pagesChange, currentPage: currentPageChange}) => {

                if (currentPageChange)
                    this.currentPage = currentPageChange.currentValue;

                if (pagesChange)
                    this.pages = pagesChange.currentValue;

                if (currentPageChange || pagesChange) {
                    this.generatePages();
                }

            };

            this.goToPage = page => {
                if(page > this.pages)
                    return;

                if(page < 1)
                    return;

                this.currentPage = page;

                if (this.onPageChange) {
                    this.onPageChange({page: page})
                }
            }
        }
    })
    .name


// WEBPACK FOOTER //
// ./src/cmsCore/PaginationControls/PaginationControlsModule.js